module.exports = __webpack_public_path__ + "static/media/apple.e0f6197b.png";